import axios from 'axios';
import { config } from '../config';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  lastActive: string;
  createdAt: string;
  updatedAt: string;
  password?: string;
}

export interface AuthResponse {
  user: User;
  token: string;
}

const API_URL = `${config.apiUrl}/api/auth`;

export class AuthService {
  private static saveCurrentUser(user: User): void {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  private static saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  static async registerEmployee(email: string, password: string, firstName: string, lastName: string): Promise<AuthResponse> {
    const response = await axios.post(`${API_URL}/register`, {
      email,
      password,
      firstName,
      lastName
    });

    const { token, user } = response.data;
    this.saveToken(token);
    this.saveCurrentUser(user);
    return { user, token };
  }

  static async login(email: string, password: string): Promise<AuthResponse> {
    const response = await axios.post(`${API_URL}/login`, {
      email,
      password
    });

    const { token, user } = response.data;
    this.saveToken(token);
    this.saveCurrentUser(user);
    return { user, token };
  }

  public static async loginAdmin(email: string, password: string): Promise<AuthResponse> {
    const response = await axios.post(`${API_URL}/login`, {
      email,
      password
    });

    const { token, user } = response.data;
    if (user.role !== 'admin') {
      throw new Error('Unauthorized: Admin access only');
    }

    this.saveToken(token);
    this.saveCurrentUser(user);
    return { user, token };
  }

  static async getAllEmployees(): Promise<User[]> {
    const response = await axios.get(`${API_URL}/employees`);
    return response.data;
  }

  static async registerAdmin(email: string, password: string, firstName: string, lastName: string): Promise<AuthResponse> {
    const response = await axios.post(`${API_URL}/register/admin`, {
      email,
      password,
      firstName,
      lastName
    });

    const { token, user } = response.data;
    this.saveToken(token);
    this.saveCurrentUser(user);
    return { user, token };
  }
}

export default AuthService;
